export class Constants {
  // Types
  public static readonly SEGURIDAD = 'seguridad';
  public static readonly OPERACION = 'operacion';
  public static readonly PERSONAL = 'personal';
  public static readonly DESPACHO = 'despacho';
  public static readonly NOVEDADES = 'novedades';
  public static readonly DESVIACIONES = 'desviaciones';
  public static readonly AVISO_AVERIAS = 'aviso_averias';
  public static readonly OT_EJECUTADAS = 'o_t_ejecutadas';
  public static readonly FUERA_SERVICIO = 'fuera_servicio';
  public static readonly TIPO_CIERE_TURNO_INFORME_DIARIO = 'cierre_turno_informe_diario';
  public static readonly TIPO_CIERRE_TURNO = 'cierre_turno';
  // Tipos de informe por perfil
  public static readonly TIPO_CIERRE_TURNO_DCS = 'cierre_turno_dcs';
  public static readonly TIPO_CIERRE_TURNO_FERRICO = 'cierre_turno_ferrico';
  public static readonly TIPO_CIERRE_TURNO_SALMUERA_II = 'cierre_turno_salmueraii';
  public static readonly TIPO_CIERRE_TURNO_SALMUERA_I = 'cierre_turno_salmuerai';
  public static readonly TIPO_CIERRE_TURNO_COMPRESION = 'cierre_turno_compresion';
  public static readonly TIPO_CIERRE_TURNO_ELECTROLIZADORES = 'cierre_turno_electrolizadores';
  public static readonly TIPO_CIERRE_TURNO_SUBESTACION = 'cierre_turno_subestacion';
  public static readonly TIPO_CIERRE_TURNO_MOVIMIENTO_PRODUCTO = 'cierre_turno_movproducto';
  // Areas
  public static readonly GENERAL = 'general';
  public static readonly CLORURO_FERRICO = 'cloruro_ferrico';
  public static readonly SALMUERA_I = 'salmuera_i';
  public static readonly SALMUERA_II = 'salmuera_ii';
  public static readonly COMPRESION = 'compresion';
  public static readonly ELECTROLIZADORES = 'electrolizadores';
  public static readonly SUBESTACION = 'subestacion';
  public static readonly MOVIMIENTO_PRODUCTO = 'movimiento_producto';
  public static readonly DCS = 'dcs';
  public static readonly AREA_CIERRE_TURNO = 'cierre_turno';
  public static readonly AREA_CIERRE_TURNO_DIARIO = 'cierre_turno_diario';
  public static readonly AREA_CIERRE_TURNO_DCS = 'cierre_turno_dcs';
  public static readonly AREA_CIERRE_TURNO_FERRICO = 'cierre_turno_ferrico';
  // Áreas especiales para cierres por perfil
  // Ajuste: backend espera 'cloruro_ferrico' como área para cierre_turno_ferrico
  public static readonly AREA_FERRICO = 'cloruro_ferrico';

  // Tipo cierres de turnos
  public static readonly INFORME_TURNO = 'informe_turno';
  public static readonly TURNO_DIARIO = 'turno_diario';
  
}
